import { render, staticRenderFns } from "./PerformerList.vue?vue&type=template&id=a5b15bea&scoped=true"
import script from "./PerformerList.vue?vue&type=script&lang=js"
export * from "./PerformerList.vue?vue&type=script&lang=js"
import style0 from "./PerformerList.vue?vue&type=style&index=0&id=a5b15bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b15bea",
  null
  
)

export default component.exports